import { useEffect } from "react";

export const VisitedChecker = ({ localStorageKey, setVisited }) => {
  useEffect(() => {
    const storedValue = localStorage.getItem(localStorageKey);

    if (storedValue != null) {
      setVisited(JSON.parse(storedValue));
    } else {
      setVisited(false);
    }
  }, [localStorageKey]);

  return null;
};
